import { bulandiIsGroupEventForRegistration } from "../data/bulandiGroupEventRegistration";

/** Sign-in closes at end of 2 Jul 2026 IST (23:59:59.999 → 3 Jul 2026 00:00:00 IST). */
export const BULANDI_EVENT_SIGN_IN_CLOSE_AT_IST_MS = Date.parse(
  "2026-07-03T00:00:00+05:30",
);

/** Event ids whose sign-in (new or changes) closes on the deadline above. Ink It stays open. */
export const BULANDI_EVENT_SIGN_IN_CLOSED_EVENT_IDS = new Set([
  "foot-loose-juniors",
  "wanna-b-picasso-juniors",
  "verse-vibes-juniors",
  "riddle-rush-juniors",
  "mic-drop-intermediates",
  "foot-loose-intermediates",
  "wanna-b-picasso-intermediates",
  "tale-spin-intermediates",
  "knives-out-intermediates",
  "brain-burn-intermediates",
  "nitro-rush-intermediates",
  "mic-drop-seniors",
  "funk-fusion-seniors",
  "mind-maze-seniors",
  "knives-out-seniors",
  "tote-studio-seniors",
  "sher-lock-key-seniors",
  "profit-or-laugh-seniors",
  "viral-voltage-seniors",
  "clash-of-clans-family",
]);

export const BULANDI_EVENT_SIGN_IN_CLOSED_LABEL = "Sign-in closed";

/**
 * @param {string} eventId
 * @param {number} [nowMs]
 */
export function isBulandiEventSignInClosed(eventId, nowMs = Date.now()) {
  if (!BULANDI_EVENT_SIGN_IN_CLOSED_EVENT_IDS.has(eventId)) return false;
  return nowMs >= BULANDI_EVENT_SIGN_IN_CLOSE_AT_IST_MS;
}

/** @param {unknown} entry */
function teammateBrFromEntry(entry) {
  if (entry && typeof entry === "object" && "br" in entry) {
    return String(entry.br ?? "").trim();
  }
  return String(entry ?? "").trim();
}

/** @param {unknown} entry */
function teammateDobFromEntry(entry) {
  if (entry && typeof entry === "object" && "dob" in entry) {
    return String(entry.dob ?? "").trim();
  }
  return "";
}

/** @param {unknown} arr */
function normalizedGroupTeammateEntries(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((entry) => ({
    br: teammateBrFromEntry(entry),
    dob: teammateDobFromEntry(entry),
  }));
}

/**
 * @param {string} eventId
 * @param {object} current
 * @param {object} baseline
 */
function groupTeammateByEventIdUnchanged(eventId, current, baseline) {
  const cur = normalizedGroupTeammateEntries(current?.[eventId]);
  const base = normalizedGroupTeammateEntries(baseline?.[eventId]);
  if (cur.length !== base.length) return false;
  for (let i = 0; i < cur.length; i += 1) {
    if (cur[i].br !== base[i].br || cur[i].dob !== base[i].dob) return false;
  }
  return true;
}

/**
 * Blocks submit when closed events were added, removed, or had teammate edits.
 * @param {object} p
 * @returns {{ error: string | null }}
 */
export function validateBulandiClosedEventSignInSubmit(p) {
  const {
    eligible,
    selectedIds,
    fromSheetIds,
    groupTeammateByEventId = {},
    baselineGroupTeammateByEventId = {},
    groupClearBrsByEventId = {},
    nowMs = Date.now(),
  } = p;

  for (const ev of eligible) {
    if (!isBulandiEventSignInClosed(ev.id, nowMs)) continue;

    const wasOnSheet = fromSheetIds.has(ev.id);
    const isSelected = selectedIds.has(ev.id);

    if (!wasOnSheet && isSelected) {
      return {
        error: `Sign-in for ${ev.name} — ${BULANDI_EVENT_SIGN_IN_CLOSED_LABEL.toLowerCase()}.`,
      };
    }
    if (wasOnSheet && !isSelected) {
      return {
        error: `You cannot withdraw from ${ev.name} — ${BULANDI_EVENT_SIGN_IN_CLOSED_LABEL.toLowerCase()}.`,
      };
    }

    if (!isSelected || !wasOnSheet) continue;

    const clearArr = groupClearBrsByEventId[ev.id];
    if (Array.isArray(clearArr) && clearArr.some((x) => String(x ?? "").trim())) {
      return {
        error: `Teammate changes for ${ev.name} are locked — ${BULANDI_EVENT_SIGN_IN_CLOSED_LABEL.toLowerCase()}.`,
      };
    }

    if (bulandiIsGroupEventForRegistration(ev.id)) {
      if (
        !groupTeammateByEventIdUnchanged(
          ev.id,
          groupTeammateByEventId,
          baselineGroupTeammateByEventId,
        )
      ) {
        return {
          error: `Teammate changes for ${ev.name} are locked — ${BULANDI_EVENT_SIGN_IN_CLOSED_LABEL.toLowerCase()}.`,
        };
      }
    }
  }

  return { error: null };
}
